
/* injects from baggage-loader */

import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { UIMixin } from '../../../mixins/uiMixin';
import { cashoutedBets, ticketScan } from '../../../actions/ui';

const CountDown = ({ propsDefaultSecond, propsSecond, secondChange, endOfWork, ...rest }) => {
    const timeout = useRef();
    const mounted = useRef(true);
    const [getSecond, setSeconds] = useState(propsDefaultSecond);

    const second = propsSecond || propsSecond === 0 ? propsSecond : getSecond;

    const updateCounter = () => propsDefaultSecond ? setSeconds(second - 1) : secondChange(second - 1);

    const workEnd = () => {
        clearTimeout(timeout.current);
        endOfWork && endOfWork(second);
    };

    useEffect(() => {
        return () => mounted.current = false;
    }, []);

    useEffect(() => {
        clearTimeout(timeout.current);
        timeout.current = setTimeout(() => {
            if (second === 0) workEnd();
            else if (mounted.current && second > 0) updateCounter();
        }, 1000);

        return () => (!mounted.current || second === 0) && workEnd();
    }, [second, mounted.current]);

    return (
        <div className="countdown-wrapper">
            {second}
        </div>
    );
};

export default connect()(UIMixin({Component: CountDown}));